var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurveySubmitted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 294,
    height: 216.5,
    viewBox: "0 0 294 216.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4882",
    "data-name": "Group 4882",
    transform: "translate(-1033 -156.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M15716.035-10037.7h134.382l-.333-155.026-20.851-.747-5.3,6.228h-81.2l-6.155-6.228-16.886.747-3.652,6.1Z",
    transform: "translate(-14603 10381.73)",
    fill: "#f3f8fc",
    stroke: "#ee5f5f",
    strokeWidth: 1,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M147,0c81.186,0,147,8.73,147,19.5S228.186,39,147,39,0,30.27,0,19.5,65.814,0,147,0Z",
    transform: "translate(1033 334)",
    fill: "#1ebf9c",
    opacity: 0.13
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_998",
    "data-name": "Line 998",
    x2: 13.631,
    transform: "translate(1222.748 184.902)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3419",
    "data-name": "Path 3419",
    d: "M397.066,82.7a8.843,8.843,0,0,1,8.8,8.9",
    transform: "translate(839.313 102.206)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_999",
    "data-name": "Line 999",
    y2: 141.32,
    transform: "translate(1245.176 193.802)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3420",
    "data-name": "Path 3420",
    d: "M405.864,453.047a8.852,8.852,0,0,1-8.8,8.9",
    transform: "translate(839.313 -117.925)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1000",
    "data-name": "Line 1000",
    x1: 112.76,
    transform: "translate(1123.619 344.026)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3421",
    "data-name": "Path 3421",
    d: "M90.041,461.951a8.855,8.855,0,0,1-8.8-8.9",
    transform: "translate(1033.578 -117.925)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1001",
    "data-name": "Line 1001",
    y1: 141.32,
    transform: "translate(1114.822 193.802)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M81.244,91.6a8.846,8.846,0,0,1,8.8-8.9",
    transform: "translate(1033.578 102.206)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1002",
    "data-name": "Line 1002",
    x2: 11.752,
    transform: "translate(1123.619 184.902)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M309.652,47.787H286.991V45.851",
    transform: "translate(906.504 124.106)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M274.764,33.457A8.4,8.4,0,0,0,266.42,25",
    transform: "translate(919.688 136.5)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1003",
    "data-name": "Line 1003",
    x1: 13.304,
    transform: "translate(1173.355 161.5)",
    fill: "none",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M221.361,25a8.414,8.414,0,0,0-8.367,8.457",
    transform: "translate(952.547 136.5)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M179.82,45.851v1.936H157.181",
    transform: "translate(986.678 124.106)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M144.937,50.625a8.414,8.414,0,0,0-8.355,8.468",
    transform: "translate(999.543 121.269)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M351.215,59.093a8.4,8.4,0,0,0-8.356-8.468",
    transform: "translate(872.676 121.269)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M136.582,71.5V89.494h82.5V71.5",
    transform: "translate(1002.133 106.859)",
    fill: "rgba(254,197,197,0)",
    stroke: "#bbcdff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613,
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4881",
    "data-name": "Group 4881",
    transform: "translate(249.998 -107.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M812.655,535.31a42.655,42.655,0,1,1,42.655-42.655A42.655,42.655,0,0,1,812.655,535.31Z",
    transform: "translate(117.346 -120.654)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check-2",
    "data-name": "check",
    d: "M812.655,535.31a42.655,42.655,0,1,1,42.655-42.655A42.655,42.655,0,0,1,812.655,535.31ZM788.5,502.273a4.954,4.954,0,0,1,0-6.967l2.511-2.5a4.529,4.529,0,0,1,6.5.073l4.436,4.6a2.263,2.263,0,0,0,3.286,0l22.607-23.3a4.531,4.531,0,0,1,6.54-.038l2.439,2.465a4.951,4.951,0,0,1,0,6.89L806.813,514a4.529,4.529,0,0,1-6.472.043Z",
    transform: "translate(117.346 -120.654)",
    fill: "#24b16f",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveySubmitted);
export default __webpack_public_path__ + "static/media/surveySubmitted.c61f1783891cc53b399783af56e3cda1.svg";
export { ForwardRef as ReactComponent };